export default "__VITE_ASSET__D88Pos2R__"